import { useEffect, useRef } from 'react';
import { useFlags, useLDClient, withLDProvider } from 'launchdarkly-react-client-sdk';

import { useSelector } from 'react-redux';

export const FEATURE_FLAGS = {
    TRANSACTIONS_V2: 'EDGE-2452-transactions',
    POLYMARKET_FEATURE: 'polymarketFeature',
    EMAIL_OTP_LOGIN: 'email-otp-login',
};

export const useFeatureFlag = (flagKey, defaultValue = false) => {
    const flags = useFlags();
    const flagValue = flags[flagKey];
    return flagValue !== undefined ? flagValue : defaultValue;
};

export const useUserIdentification = () => {
    const ldClient = useLDClient();
    const user = useSelector(state => state.Auth.user);
    const lastUserRef = useRef();

    useEffect(() => {
        if (ldClient && lastUserRef.current !== user) {
            const context = user ? {
                kind: 'user',
                key: user.id || user.email || 'unknown-user',
                anonymous: false,
                name: user.name || `${user.firstName} ${user.lastName}`.trim(),
                email: user.email,
                custom: {
                    registrationDate: user.createdAt ? new Date(user.createdAt).getTime() : undefined,
                    lastLoginDate: user.lastLogin ? new Date(user.lastLogin).getTime() : undefined,
                }
            } : {
                kind: 'user',
                key: 'anonymous-user',
                anonymous: true
            };
            
            ldClient.identify(context);
            lastUserRef.current = user;
        }
    }, [ldClient, user]);
};

export const FeatureFlagUserProvider = ({ children }) => {
    useUserIdentification();
    return children;
};

export const createFeatureFlagProvider = (App) => {
    const clientId = process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID;

    if (!clientId) return App;
    
    const anonymousContext = {
        kind: 'user',
        key: 'anonymous-user',
        anonymous: true
    };
    
    return withLDProvider({
        clientSideID: clientId,
        context: anonymousContext,
        reactOptions: {
            useCamelCaseFlagKeys: false
        }
    })(App);
}; 